import React, { FC } from 'react';
import styled from 'styled-components';

import { BalanceMethod } from '~/api/finance/financeApiTypes';
import { choosePaySelector } from '~/feature/finance/BuyingSteps/ChoosePay/choosePay.selector';
import { useAppSelector } from '~/store';

import { DefaultMethodPaymentParams, MethodPaymentTemplate } from '../MethodPaymentTemplate';
import { BalanceChoosePayIcon } from './BalanceMethodPaymentIcon';

interface BalanceMethodPaymentProps extends DefaultMethodPaymentParams {
  price: number;
  method: BalanceMethod;
}

export const BalanceMethodPayment: FC<BalanceMethodPaymentProps> = ({
  method, price, onCheck, ...props
}) => {
  const { activeMethod } = useAppSelector(choosePaySelector);

  const isDisabled = method?.sum < price;

  return (
    <MethodPaymentTemplate
      Logo={(
        <SCBalanceChoosePayIcon
          data-is-disabled={isDisabled}
        />
      )}
      Text={(
        <>
          Личный счет
          {' '}
          <br />
          {method.sum}
          {' '}
          руб.
        </>
      )}
      isDisabled={isDisabled}
      onCheck={() => {
        if (onCheck) {
          onCheck(method);
        }
      }}
      {...props}
    />
  );
};

const SCBalanceChoosePayIcon = styled(BalanceChoosePayIcon)`
  width: 35px;
  height: 35px;
  fill: var(--black-color);

  &[data-is-disabled="true"] {
    fill: var(--gray3-color);
  }
`;
